export default __webpack_public_path__ + "fbd742d74a078796413540666d59504a.svg";